// extracted by mini-css-extract-plugin
export var tkMyriadProSemiCondensed = "Tooltip--tk-myriad-pro-semi-condensed--Z8VqR";
export var tooltipBox = "Tooltip--tooltipBox--spPZw";
export var tooltipBox__trigger = "Tooltip--tooltipBox__trigger--g9AAl";
export var tooltipBox__wrapper = "Tooltip--tooltipBox__wrapper--AzOvu";
export var tooltipBox__wrapper__arrow = "Tooltip--tooltipBox__wrapper__arrow--XVdec";